module.exports = __webpack_public_path__ + "static/media/arch-v2-translucent.7c95eb67.png";